import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
import { SessionEventArgs } from "./Exports";
/**
 * Defines payload for connection events like Connected/Disconnected.
 * Added in version 1.2.0
 */

export var ConnectionEventArgs = /*#__PURE__*/function (_SessionEventArgs) {
  _inherits(ConnectionEventArgs, _SessionEventArgs);

  var _super = _createSuper(ConnectionEventArgs);

  function ConnectionEventArgs() {
    _classCallCheck(this, ConnectionEventArgs);

    return _super.apply(this, arguments);
  }

  return ConnectionEventArgs;
}(SessionEventArgs);